export default __webpack_public_path__ + "static/media/right_arrow.b044e9c9.svg";